import { Toast, ToastContent, ToastIndicator, ToastTitle, ToastDescription } from "@heroui/react";

export function CustomToast({ toast: toastItem }) {
  const content = toastItem.content;

  return (
    <Toast
      className="rounded-xl border border-border bg-[#FFFFFF100]  "
      toast={toastItem}
      variant={content.variant}
    >
      <ToastContent>
        <div className="flex items-center gap-2">
          <div className="rounded-full bg-foreground text-background">
            <img src="/fav.png" width={24} alt="" />
          </div>
          <div className="flex flex-col pr-6">
            <div className="flex items-center gap-2">
              {content.title ? (
                <ToastTitle className="text-foreground text-[15px] font-medium">{content.title}</ToastTitle>
              ) : null}
              <ToastIndicator className="text-accent-soft-foreground" variant={content.variant} />
            </div>
            {content.description ? <ToastDescription>{content.description}</ToastDescription> : null}
          </div>
        </div>
      </ToastContent>
      <Toast.CloseButton className="absolute top-1/2 right-2 -translate-y-1/2 border-none bg-transparent opacity-100 [&>svg]:size-4" />
    </Toast>
  );
}
